import { Tabs, Tab, Typography, Box } from "@mui/material";
import { useState } from "react";
import ReusableTab from "../Components/ReusableTab";

export default function JobMetaMaster() {
  const [tab, setTab] = useState(0);

  const tabs = [
    { label: "Connectors", type: "connectors" },
    { label: "Endpoints", type: "endpoints" },
    { label: "Playbook", type: "playbook" },
  ];

  return (
    <Box p={2}>
     

      <Tabs value={tab} onChange={(e, v) => setTab(v)}>
        {tabs.map((t, index) => (
          <Tab
            key={index}
            label={t.label}
            sx={{
              textTransform: "none",
              fontSize: "16px",
              fontWeight:600
            }}
          />
        ))}
      </Tabs>

      <ReusableTab type={tabs[tab].type} />
    </Box>
  );
}
